import LoadingButton from "@/components/common/form/loading-button";
import { getCookie } from "cookies-next";
import { signOut } from "next-auth/react";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";

interface IExistingAccountLinkProps {
  className?: string;
}

const ExistingAccountLink = ({ className }: IExistingAccountLinkProps) => {
  const loginUrl = useMemo(() => {
    const integrationType = getCookie("cnb_i_type");
    const searchParams = new URLSearchParams();
    if (integrationType) {
      searchParams.set("redirect_url", `/i/${integrationType}/connect`);
    }

    if (searchParams.size !== 0) {
      return `/v2/login?${searchParams.toString()}`;
    }
    return "/v2/login";
  }, []);

  return (
    <div className={twMerge("flex items-center justify-center", className)}>
      <p>이미 코드앤버터 계정이 있으신가요?</p>
      <LoadingButton
        theme="text"
        onClick={() =>
          signOut({
            callbackUrl: loginUrl,
          })
        }
      >
        로그인
      </LoadingButton>
    </div>
  );
};

export default ExistingAccountLink;
